import type { FigmaIconProps } from './types';

export const IconFigmaHamburger = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x={4} y={7} width={16} height={1.6} rx={0.8} fill={color} />
    <rect x={4} y={11.2} width={16} height={1.6} rx={0.8} fill={color} />
    <rect x={4} y={15.4} width={16} height={1.6} rx={0.8} fill={color} />
  </svg>
);
